import type { Inspection } from "@entities/inspection/types";

const getDateFromNow = (days: number): string => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString().split("T")[0];
};

export const mockInspections: Inspection[] = [
  {
    id: "insp-1",
    accountId: "1",
    assetId: "asset-1",
    assignedToId: "per-14",
    title: "Jahresinspektion Etagenofen Wiesheu EBO 86",
    type: "inspection",
    workflowStatus: "open",
    dueTimingStatus: "upcoming",
    description:
      "Jährliche Sicherheits- und Funktionsinspektion des Etagenofens gemäß Herstellervorgaben.",
    scheduledDate: getDateFromNow(14),
    isExternal: false,
    areTasksPaused: false,
    intervalMode: "fixed_date",
    intervalType: "yearly",
    intervalNumber: 1,
    durationHours: 3,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "insp-2",
    accountId: "1",
    assetId: "asset-4",
    assignedToId: "per-14",
    title: "Wartung Konvektomat Rational iCombi Pro",
    type: "maintenance",
    workflowStatus: "open",
    dueTimingStatus: "due",
    description:
      "Vierteljährliche Wartung: Reinigung Dampfgenerator, Inspektion der Dichtungen, Kalibrierung Temperaturfühler.",
    scheduledDate: getDateFromNow(2),
    isExternal: false,
    areTasksPaused: false,
    intervalMode: "relative",
    intervalType: "monthly",
    intervalNumber: 3,
    durationHours: 2,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "insp-3",
    accountId: "1",
    assetId: "asset-5",
    assignedToId: "per-15",
    title: "Kältewartung Kühltheke",
    type: "maintenance",
    workflowStatus: "open",
    dueTimingStatus: "overdue",
    description: "Kältemittelstand prüfen, Kondensator reinigen, Temperaturen protokollieren.",
    scheduledDate: getDateFromNow(-5),
    overdueDays: 5,
    isExternal: true,
    areTasksPaused: false,
    intervalMode: "relative",
    intervalType: "monthly",
    intervalNumber: 6,
    durationHours: 2,
    durationMinutes: 30,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "insp-4",
    accountId: "1",
    assetId: "asset-8",
    assignedToId: "per-17",
    title: "Jährliche Inspektion Spülmaschine Winterhalter",
    type: "inspection",
    workflowStatus: "completed",
    dueTimingStatus: "scheduled",
    description: "Jährliche Inspektion: Wasserqualität, Düsenzustand, Dosieranlage.",
    scheduledDate: getDateFromNow(-30),
    completedDate: getDateFromNow(-28),
    isExternal: false,
    areTasksPaused: false,
    intervalMode: "fixed_date",
    intervalType: "yearly",
    intervalNumber: 1,
    durationHours: 2,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "insp-5",
    accountId: "1",
    assetId: "asset-9",
    assignedToId: "per-15",
    title: "Sicherheitsinspektion Tiefkühlschrank",
    type: "inspection",
    workflowStatus: "open",
    dueTimingStatus: "due",
    description: "Temperaturkalibrierung, Türdichtungen prüfen, Abtauautomatik testen.",
    scheduledDate: getDateFromNow(1),
    isExternal: false,
    areTasksPaused: false,
    intervalMode: "relative",
    intervalType: "monthly",
    intervalNumber: 3,
    durationHours: 1,
    durationMinutes: 30,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "insp-6",
    accountId: "1",
    assetId: "asset-2",
    assignedToId: "per-14",
    title: "Halbjahreswartung Etagenofen EBO 64",
    type: "maintenance",
    workflowStatus: "open",
    dueTimingStatus: "upcoming",
    description: "Brennerdüsen reinigen, Zündelektroden prüfen, Isolierung kontrollieren.",
    scheduledDate: getDateFromNow(21),
    isExternal: false,
    areTasksPaused: false,
    intervalMode: "relative",
    intervalType: "monthly",
    intervalNumber: 6,
    durationHours: 4,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "insp-7",
    accountId: "1",
    assetId: "asset-11",
    assignedToId: "per-15",
    title: "Notfallinspektion Tiefkühler",
    type: "inspection",
    workflowStatus: "completed",
    dueTimingStatus: "scheduled",
    description: "Notfallinspektion nach Totalausfall. Kompressor ausgetauscht.",
    scheduledDate: getDateFromNow(-2),
    completedDate: getDateFromNow(-1),
    isExternal: true,
    areTasksPaused: false,
    durationHours: 6,
    cost: 850,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "insp-8",
    accountId: "1",
    assetId: "asset-13",
    assignedToId: "per-15",
    title: "Kältewartung Kühltheke Filiale 4",
    type: "maintenance",
    workflowStatus: "open",
    dueTimingStatus: "overdue",
    description: "Kompressorgeräusche untersuchen, Kältemittel prüfen.",
    scheduledDate: getDateFromNow(-3),
    overdueDays: 3,
    isExternal: true,
    areTasksPaused: false,
    intervalMode: "relative",
    intervalType: "monthly",
    intervalNumber: 6,
    durationHours: 3,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
